import {Observable} from 'rxjs';
import {isNullOrUndefined} from 'util';
import {EventEmitter, Injectable} from '@angular/core';
import {MensagensService} from 'max-ng-lib';
import {HttpClient} from '@angular/common/http';
import {GenericRoteirizadorService} from '../../../core/services/generic-roteirizador.service';
import {FiltroSelectedConfig} from '../components/roteirizacao/component/filtro-dialog/config/filtro-selected.config';
import {FiltroRoteirizacaoService} from '../components/roteirizacao/component/filtro-dialog/config/filtro-roteirizacao.service';
import {NgxIndexedDBService} from 'ngx-indexed-db';
import {IndexedDbModel} from '../models/indexed-db.model';

@Injectable({ providedIn: 'root' })
export class EntregaPedidoService extends GenericRoteirizadorService {
  public entregasSemLocalizacao = new EventEmitter<number>();

  constructor(private mensagensService: MensagensService,
              private filtroRoteirizacaoService: FiltroRoteirizacaoService,
              private httpClient: HttpClient,
              private dbService: NgxIndexedDBService) {
    super();
  }

  getMensagensService(): MensagensService {
    return this.mensagensService;
  }

  getHttpClient(): HttpClient {
    return this.httpClient;
  }

  getUrlRecurso(): string {
    return '/entregaPedidos';
  }

  consultar(filtro: FiltroSelectedConfig, exibirLoading = false) {
    return this.post<any[]>('/consultar', { dados: filtro, exibirLoading });
  }

  salvarPedidosLocalStorage(content) {
    this.dbService.clear(IndexedDbModel.DB_ROTEIRIZAZAO_LISTA_ENTREGAS).subscribe((response) => {
      this.dbService.add(IndexedDbModel.DB_ROTEIRIZAZAO_LISTA_ENTREGAS, content).subscribe((teste) => {
      });
    });
  }

  getPedidosLocalStorage(): Observable<Array<{ entregas: any }>> {
    try {
      return this.dbService.getAll(IndexedDbModel.DB_ROTEIRIZAZAO_LISTA_ENTREGAS);
    } catch (error) {
      console.log(error.message);
    }
  }

  public removerPedidosStorage() {
    try {
      this.dbService.clear(IndexedDbModel.DB_ROTEIRIZAZAO_LISTA_ENTREGAS).subscribe(() => {});
    } catch (error) {
      console.log(error.message);
    }
  }

  listarPedidosPendentesClienteEntrega(listaClientes, exibirLoadingAoPesquisar = true) {
    let filtro: FiltroSelectedConfig = this.filtroRoteirizacaoService.filtro;
    if (isNullOrUndefined(filtro)) {
      filtro = {};
    }
    filtro.clientes = listaClientes;

    return this.post<any[]>('/listarPedidosPendentesClienteEntrega', {
      dados: filtro,
      exibirLoading: exibirLoadingAoPesquisar
    });
  }
}
